import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["counter"]
  static values = { max: { type: Number, default: 5000 } }

  connect() {
    this.editor = this.element.querySelector("trix-editor")
    if (this.editor) {
      this.editor.addEventListener("trix-change", () => this.update())
      this.update()
    }
  }

  update() {
    const length = this.editor?.editor?.getDocument()?.toString()?.trim()?.length || 0
    const remaining = this.maxValue - length
    this.counterTarget.textContent = remaining.toLocaleString()

    if (remaining < 0) {
      this.counterTarget.classList.add("text-red-600", "font-semibold")
      this.counterTarget.classList.remove("text-gray-500")
    } else if (remaining < 1000) {
      this.counterTarget.classList.add("text-orange-500")
      this.counterTarget.classList.remove("text-gray-500", "text-red-600", "font-semibold")
    } else {
      this.counterTarget.classList.add("text-gray-500")
      this.counterTarget.classList.remove("text-orange-500", "text-red-600", "font-semibold")
    }
  }
}
